module.exports = __webpack_public_path__ + "img/chicaconlaptodphone.5c6fbf90.png";